export default "__VITE_ASSET__CLd7l8pV__"